export default __webpack_public_path__ + "static/media/1704.c9a18d31.png";